import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/center-loading';
import { Row, Col } from 'react-flexbox-grid';
import { SelectBox } from "components/uikit-adapter/index";
import StyledFilterMaterial from './StyledFilterMaterial';
import intl from 'react-intl-universal';
import { validateObjectsAreEqual } from 'utils/custom-functions';
import { useFilterData } from './useFilterData';
import Button from 'components/button';

const materialFiltersDefault = {
  IdMaterial: null,
  IdFamilia: null,
  IdFamiliaRotulada: null,
  IdCarteira: null
}

const FiltroMaterial = ({ initialFilters, handleClose }) => {
  const {
    loadingStates,
    isLoading,
    data,
    actions
  } = useFilterData();

  const [formState, setFormState] = useState(materialFiltersDefault);

  useEffect(() => {    
    loadFiltersData();
  }, []);

  useEffect(() => {
    if (!validateObjectsAreEqual(initialFilters, formState)) {
      setFormState(prev => ({
        ...prev,
        IdFamilia: initialFilters.IdFamilia,
        IdMaterial: initialFilters.IdMaterial,
        IdCarteira: initialFilters.IdCarteira,
        IdFamiliaRotulada: initialFilters.IdFamiliaRotulada,
      }));
    }
  }, [initialFilters]);

  const loadFiltersData = async () => {
    try {
      await Promise.all([
        actions.fetchMaterials(),
        actions.fetchWallets(),
        actions.fetchFamilies(),
        actions.fetchLabeledFamilies()
      ]);
    } catch (error) {
      console.error('Error loading initial filters data:', error);
    }
  };

  const handleChange = async (name, value) => {
    setFormState(prev => ({ ...prev, [name]: value }));
    
    if (name === 'IdCarteira' && value != null) {
      await actions.fetchFamilies();
      setFormState(prev => ({
        ...prev,
        IdFamilia: null,
        IdFamiliaRotulada: null
      }));
    } else if (name === 'IdFamilia' && value != null) {
      await actions.fetchLabeledFamilies();
      setFormState(prev => ({
        ...prev,
        IdFamiliaRotulada: null
      }));
    }
  };

  const handleCleanClick = () => {
    setFormState(prev => ({ ...prev, ...materialFiltersDefault }));
    handleClose(materialFiltersDefault);
  };

  const handleCloseSearch = () => {
    const params = {
      IdCarteira: formState.IdCarteira,
      IdFamilia: formState.IdFamilia,
      IdFamiliaRotulada: formState.IdFamiliaRotulada,
      IdMaterial: formState.IdMaterial,
    };
    handleClose(params);
  };

  return (
    <StyledFilterMaterial>
      <Loading isLoading={isLoading} />
      <div className="filter-container">
        <div className="sideFilterFields">
          <Row>
            <Col xs={12} lg={12} md={12}>
              <SelectBox
                name='carteira'
                label={intl.get('commons.wallet')}
                value={formState.IdCarteira}
                options={data.wallets}
                valueKey='Id'
                labelKey='Description'
                onChange={value => handleChange('IdCarteira', value === null ? null : value.Id)}
                placeholder={intl.get('commons.wallet')}
                searchable
                openOnFocus
                clearable
                isLoading={loadingStates.wallets}
                data-testid='filtro-material-selectbox-wallet'
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={12} md={12}>
              <SelectBox
                name='familia'
                label={intl.get('commons.family')}
                value={formState.IdFamilia}
                options={data.families}
                valueKey='Id'
                labelKey='Name'
                onChange={value => handleChange('IdFamilia', value === null ? null : value.Id)}
                placeholder={intl.get('commons.family')}
                clearValueText='Limpar'
                searchable
                openOnFocus
                clearable
                isLoading={loadingStates.families}
                data-testid='filtro-material-selectbox-family'
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={12} md={12}>
              <SelectBox
                name='familiaRotulada'
                label={intl.get('commons.labeledFamily')}
                value={formState.IdFamiliaRotulada}
                options={data.labeledFamilies}
                valueKey='Id'
                labelKey='Description'
                onChange={value => handleChange('IdFamiliaRotulada', value === null ? null : value.Id)}
                placeholder={intl.get('commons.labeledFamily')}
                clearValueText='Limpar'
                searchable
                openOnFocus
                clearable
                isLoading={loadingStates.labeledFamilies}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={12} md={12}>
              <SelectBox
                name='material'
                label={intl.get('commons.material')}
                value={formState.IdMaterial}
                options={data.materials}
                valueKey='Id'
                labelKey='MaterialSearch'
                onChange={value => handleChange('IdMaterial', value === null ? null : value.Id)}
                placeholder={intl.get('commons.material')}
                clearValueText='Limpar'
                searchable
                openOnFocus
                clearable
                isLoading={loadingStates.materials}
              />
            </Col>
          </Row>
        </div>

        <Row className="footerFilterContainer no-margin">
          <Col xs={12}>
            <Row>
              <Col xs={12} lg={12} md={12}>
                <hr className="filter-divisor" />
              </Col>
            </Row>
            <Row>
              <Col xs={6} lg={6} md={6}>
                <Button buttonType="primary" onClick={handleCloseSearch} value={intl.get('filters.search')} />
              </Col>
              <Col xs={6} lg={6} md={6}>
                <Button onClick={handleCleanClick} value={intl.get('filters.cleanSearch')} />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </StyledFilterMaterial>
  );
};

FiltroMaterial.propTypes = {
  initialFilters: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
};

FiltroMaterial.defaultProps = {
  initialFilters: {}
};

export default FiltroMaterial;
